import { useState, useEffect, useCallback } from "react";
import { api } from "@/contexts/AuthContext";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { ListChecks, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";

export const OutstandingSurveys = () => {
  const [sends, setSends] = useState([]);

  const load = useCallback(() => {
    api.get("/survey-sends?scope=mine").then(({ data }) => setSends(data || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const complete = async (id) => {
    try {
      await api.post(`/survey-sends/${id}/complete`);
      toast.success("Survey marked complete");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed to complete"); }
  };

  if (sends.length === 0) return null;
  return (
    <Card className="border-amber-300 bg-amber-50/30" data-testid="outstanding-surveys-card">
      <CardHeader className="pb-2">
        <CardTitle className="text-sm flex items-center gap-2 uppercase tracking-wider text-[#7A8A84]">
          <ListChecks className="h-4 w-4 text-amber-600" /> Outstanding surveys — you own these
          <Badge className="bg-amber-100 text-amber-900 border border-amber-300 ml-auto">{sends.length}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        <ul>
          {sends.map((s) => (
            <li key={s.id} className="flex items-center justify-between gap-3 py-2 border-b border-amber-100 last:border-0" data-testid={`outstanding-survey-${s.id}`}>
              <div className="min-w-0">
                <p className="text-sm font-medium text-[#1C1F1E] truncate">{s.survey_name} — {s.visitor_name}</p>
                <p className="text-[11px] text-[#7A8A84]">
                  sent {new Date(s.first_sent_at).toLocaleDateString()} · {s.accessed_at ? "link opened" : `not opened yet (${s.reminder_count || 0} reminders)`}
                </p>
              </div>
              <Button size="sm" variant="outline" className="border-emerald-300 text-emerald-800 h-7 text-xs shrink-0"
                      onClick={() => complete(s.id)} data-testid={`complete-outstanding-${s.id}`}>
                <CheckCircle2 className="h-3 w-3 mr-1" /> Survey complete
              </Button>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
